<template>
    <section class="col s12">
        <div class="row">
            <div class="col s12">
                <p>Sua ação responde ou está vinculada a alguma política pública que seja prioritária para o desenvolvimento local, regional ou nacional?</p> 

                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_politicas_publicas"
                               class="with-gap"
                               type="radio"
                               id="rdSimAcaoPoliticasPublicas"
                               :disabled="allDisabled"
                               :value="true"
                               v-model="acaoPoliticasPublicas" />
                        <span>Sim</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_politicas_publicas"

                               class="with-gap"
                               type="radio"
                               id="rdNaoAcaoPoliticasPublicas"
                               :disabled="allDisabled"
                               :value="false"
                               v-model="acaoPoliticasPublicas" />
                        <span>Não</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="row" v-if="acaoPoliticasPublicas">
            <section class="animate__animated animate__fadeInDown">
                <div class="col s12">
                    <p><b>Qual política e como?</b></p>
                </div>

                <div class="col s12">
					<textarea style="width: 100%; min-height: 150px;" name="descAcaoPoliticasPublicas"
								  id="descAcaoPoliticasPublicas"
								  maxlength="2000"
								  :disabled="allDisabled"
								  v-model="descAcaoPoliticasPublicas"
								  cols="30" rows="10"
								  class="browser-default">
					</textarea>            
					<span class="right" style="font-size: small;">{{ !descAcaoPoliticasPublicas ? 0 : descAcaoPoliticasPublicas.length }} / 2000</span>
				</div>
            </section>
        </div>

        <Resultado_avaliacoes_itens_acao v-if="avaliacoes"
                                         :avaliacoes="avaliacoes"
                                         campo-referente-na-inscricao="acao_politicas_publicas"></Resultado_avaliacoes_itens_acao>
    </section>
</template>

<script>
import 'animate.css';
import Resultado_avaliacoes_itens_acao from "./avaliacoes_resultado/resultado_avaliacoes_itens_acao";

export default {
    name: "inscricao_acao_politicas_publicas",
    components: {Resultado_avaliacoes_itens_acao},
    props: {
        pAcaoPoliticasPublicas: {
            type: Boolean,
            default: false,
        },
        pDescAcaoPoliticasPublicas: {
            type: String,
            default: null,
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
        pAvaliacoes: {
            type: Array|null,
            default: null,
        }
    },
    data() {
        return {
            acaoPoliticasPublicas: this.pAcaoPoliticasPublicas,
            descAcaoPoliticasPublicas: this.pDescAcaoPoliticasPublicas,
            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pAcaoPoliticasPublicas(newValue) {
            this.acaoPoliticasPublicas = newValue
        },
        acaoPoliticasPublicas(newValue) {
            
            this.$emit('update:pAcaoPoliticasPublicas', newValue)
        },
        pDescAcaoPoliticasPublicas: {
            deep: true,
            handler(newValue){
                this.descAcaoPoliticasPublicas = newValue
            }
        },
        descAcaoPoliticasPublicas: {
            deep: true,
            handler(newValue){
                this.$emit('update:pDescAcaoPoliticasPublicas', newValue)
            }
        },
    },
}
</script>
